__turbopack_context__.v({
  "questionnaireNavigationLoadingDesktop": "QuestionnaireNavigationLoading-module__c6s90W__questionnaireNavigationLoadingDesktop",
  "questionnaireNavigationLoadingTablet": "QuestionnaireNavigationLoading-module__c6s90W__questionnaireNavigationLoadingTablet",
});
